var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTwitter01(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 20,
    viewBox: "0 0 25 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.899902 17.3125C2.88553 18.4611 5.19065 19 7.6499 19C14.9399 19 20.8822 13.2209 21.1409 5.99275L23.3999 1.5625L19.6267 2.125C18.8045 1.39996 17.7461 0.999932 16.6499 1C13.7564 1 11.5874 3.83162 12.2849 6.6025C8.2889 6.86125 4.66753 4.39862 2.57278 1.11813C1.18228 5.83975 2.47153 11.5255 5.9624 15.0299C5.9624 16.3529 2.5874 17.1426 0.899902 17.3125Z",
    stroke: "#535353",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter01);
export default __webpack_public_path__ + "static/media/twitter01.eb0978779c03fd93d20ce0a895a1b53c.svg";
export { ForwardRef as ReactComponent };